import { useMutation } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export interface IFetchSocialAccountStatusPayload {
    social_account_ids: number[];
}

export interface IFetchSocialAccountStatusResponse {
    data: Record<string, "pending" | "in_progress" | "finished" | "failed" | "not_found">;
}

export const useFetchSocialAccountStatus = () => {
    return useMutation<
        IFetchSocialAccountStatusResponse,
        Error,
        IFetchSocialAccountStatusPayload
    >({
        mutationFn: async (payload) => {
            return httpService.post<
                IFetchSocialAccountStatusResponse,
                IFetchSocialAccountStatusPayload
            >(API_CONFIG.path.socialAccountStatus, payload);
        },
    });
};
